module.exports = __webpack_public_path__ + "static/media/gandhi_mask.948bfad0.png";